import { Component, Input } from '@angular/core';
import { Question, QuestionCondition } from '@app/core/models/questionnaire.model';
import { CommonModule } from '@angular/common';
import { QuestionSubType } from '@app/core/enums/questionnaire.enums';

const RATING_PARAM = 'RATING';
const STAR_COUNT = 5;

@Component({
  selector: 'app-social-review',
  imports: [CommonModule],
  templateUrl: './social-review.html',
  styleUrl: './social-review.scss'
})
export class SocialReview {
  @Input() question: Question | null = null;
  questionSubType = QuestionSubType;

  /** Selected star rating (1–5), same concept as RatingScale */
  selectedRating: number | null = null;

  /** 1-based star indices for 5-star rating template */
  readonly ratingStars = Array.from({ length: STAR_COUNT }, (_, i) => i + 1);

  selectRating(value: number, event: Event): void {
    event.stopPropagation();
    this.selectedRating = value;
  }

  /** First question condition with parameter RATING, if any */
  getRatingCondition(): QuestionCondition | null {
    const conditions = this.question?.questionConditions;
    if (!conditions?.length) return null;
    return conditions.find((c: QuestionCondition) => c?.parameter === RATING_PARAM) ?? null;
  }

  /** Whether to show the 5-star rating block (has RATING condition) */
  get showRatingStars(): boolean {
    return this.getRatingCondition() != null;
  }

  /** Label for condition e.g. "If rating is ≥ 4" */
  getRatingConditionLabel(condition: QuestionCondition): string {
    const op = condition?.operator;
    const val = condition?.value ?? '';
    const opLabel = op === 'EQUALS' ? '=' : op === 'GREATER_THAN' ? '≥' : op === 'LESS_THAN' ? '<' : op === 'GREATER_THAN_OR_EQUAL' ? '≥' : op === 'LESS_THAN_OR_EQUAL' ? '≤' : '';
    return `If rating is ${opLabel} ${val}`.trim();
  }
}
